import { ActionType, createAction } from "typesafe-actions";

import { Person } from "@mapmycustomers/shared/types/entity";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import ApiService from "@app/store/api/ApiService";

// WARNING! Only use this action when you can't get person from the store
export const fetchPerson = createAction("@person/fetchPerson")<{
  callback: (person: Person) => void;
  // False when the caller renders its own inline failure state. Defaults to true so
  // existing call sites keep the global toast they have always had.
  displayNotification?: boolean;
  // Passed the error so a caller can branch on its status — a 404/403 is a permanent
  // "you can't see this record", anything else is worth retrying.
  failureCallback?: (error?: unknown) => void;
  id: Person["id"];
  options?: Parameters<ApiService["fetchPerson"]>[2];
}>();

export const fetchPeople = createAction("@person/fetchPeople")<{
  callback: (person: ListResponse<Person>) => void;
  failureCallback?: () => void;
  options?: Parameters<ApiService["fetchPeople"]>[1];
}>();

export type Actions = ActionType<typeof fetchPeople | typeof fetchPerson>;
